const utils = require('../../../lib/utils')

module.exports = {
    config: {
        momentDateFormat: 'DD.MM.YYYY HH:mm',
        tooltips: {
            code: {
                flavor: 'default',
                titleKey: 'form.fields.timeRangeByCode.tooltip.default.title',
                titleRightKey: 'form.fields.timeRangeByCode.tooltip.default.titleRight',
                messageKey: 'form.fields.timeRangeByCode.tooltip.default.message',
                orientation: 'E',
            }
        },
        showUsageTooltip: true
    },

    model: {
        formatted: {
            code:   false,
            from:   false,
            to:     false,
        },

        dataJSON: {},

        // config: {
        //     momentDateFormat: 'DD.MM.YYYY HH:mm', // format to use for timestamp-labels
        //     showUsageTooltip: true, // the usage tooltip shows all formats regardless of the grantedFormat. one might turn it off here to prevent confusion.
        //     grantedFormat: { // which formats should be supported. non-granted formats will be translated if possible.
        //         month: true,
        //         quarter: true,
        //         year: true,
        //     },
        //     separatedFieldCodes: { // overwrite values if necessary
        //         code:   'code',
        //         from:   'from',
        //         to:     'to',
        //     },
        // }
    },

    events: {
        onChange: {
            type: 'change',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                const self = event.data.component;
                self.updateValue(self.$.find('input[type="text"]').val(), true)
            }
        },
    },

    methods: {
        prepare(){
            // sanitize grantedFormat
            const fieldConfig   = this.model.config = this.model.config || {}
            const grantedFormat = fieldConfig.grantedFormat = fieldConfig.grantedFormat || {}
            grantedFormat.month     = grantedFormat.month === false ? false : true
            grantedFormat.quarter   = grantedFormat.quarter === false ? false : true
            grantedFormat.year      = grantedFormat.year === false ? false : true

            // the tooltip has to be changed according to which formats are granted.
            this.config.tooltips.code.flavor = `${grantedFormat.month ? 'm' : ''}${grantedFormat.quarter ? 'q' : ''}${grantedFormat.year ? 'y' : ''}`

            // set init data
            this.updateValue(this.model.dataJSON.code)
            this.updateData()
        },

        updateValue(value){
            let valueChanged = false;
            if(value !== undefined){
                if(!value) value = null;

                value = this.cleanupValue(value)

                valueChanged = this.model.dataJSON.code !== value;
                this.model.dataJSON.code = value;
            }

            if(valueChanged){
                this.updateData()

                if(this.model.dataJSON.code !== undefined){
                    this.triggerClosest('onChildChanged', {
                        fieldCode:  this.model.fieldCode,
                        value:      this.model.dataJSON
                    });
                }

                this.refresh(false)
            }
        },

        cleanupValue(value){
            if(!value) return value;
            return String(value).replace(/\s+/g, '').toUpperCase().replace(/[^Q\d]+/g, '-')
        },

        updateData(){
            const fieldConfig   = this.model.config || {}
            const grantedFormat = fieldConfig.grantedFormat || {}
            const code          = this.model.dataJSON.code
            const codeParts     = String(code || '').match(/^([\d]{2,4})?[-_]*([Q])?([\d]{1,2})?$/i)
            const dateFormat    = fieldConfig.momentDateFormat || this.config.momentDateFormat
            let baseDate        = ''
            let baseDateUnit    = ''
            let formattedCode   = ''

            if(codeParts !== null){
                let year = codeParts[1] * 1
                let quarter = 0
                let month = 0

                if(codeParts[2]){
                    quarter = codeParts[3] * 1
                    if(isNaN(quarter)) quarter = 0;
                } else {
                    month = codeParts[3] * 1
                    if(isNaN(month)) month = 0;
                }

                let validQuarterFound = quarter > 0 && quarter < 5
                let validMonthFound = month > 0 && month < 13

                if(codeParts[1] === undefined) {
                    // treat months without year (in case of single digits) as years above 2000
                    if(validMonthFound && !grantedFormat.month){
                        year = month
                        validMonthFound = false
                        month = 0
                    }
                    // set year of relative months or quarters
                    else if(validQuarterFound || validMonthFound){
                        year = new Date().getFullYear()
                    }
                }
                if(year < 1000){
                    // treat year as month if necessary
                    if(year > 0 && year < 13 && !validQuarterFound && !validMonthFound && grantedFormat.month){
                        month = year
                        year = new Date().getFullYear()
                        validMonthFound = true
                    }
                    // use 1-, 2- or 3-digit year
                    else {
                        year += 2000
                    }
                }

                // transform quarters to months and vice versa if necessary
                if(year){
                    if(validQuarterFound && !grantedFormat.quarter && grantedFormat.month){
                        month = quarter * 3 - 2
                        validMonthFound = true
                    } else if(!validQuarterFound && validMonthFound && grantedFormat.quarter && !grantedFormat.month){
                        quarter = Math.floor((month + 4) / 4)
                        validQuarterFound = true
                    }
                }

                // format base values
                if(year){
                    if(validQuarterFound && grantedFormat.quarter){
                        baseDate        = `${year}-${String(quarter * 3).padStart(2, '0')}-15T00:00:00.000`
                        baseDateUnit    = 'quarter'
                        formattedCode   = `${year}-Q${quarter}`
                    } else if(validMonthFound && grantedFormat.month){
                        baseDate        = `${year}-${String(month).padStart(2, '0')}-15T00:00:00.000`
                        baseDateUnit    = 'month'
                        formattedCode   = `${year}-${month}`
                    } else if(grantedFormat.year !== false && grantedFormat.year) {
                        baseDate        = `${year}-01-15T00:00:00.000`
                        baseDateUnit    = 'year'
                        formattedCode   = `${year}`
                    }
                }
            }

            // format values
            if(baseDate && baseDateUnit) {
                const m     = utils.moment(baseDate)
                const from  = m.clone().startOf(baseDateUnit)
                const to    = m.add(1, baseDateUnit).startOf(baseDateUnit)

                this.model.dataJSON.from    = from.format()
                this.model.dataJSON.to      = to.format()
                this.model.formatted.from   = from.format(dateFormat)
                this.model.formatted.to     = to.format(dateFormat)

                if(formattedCode){
                    this.model.dataJSON.code = formattedCode
                }
            } else {
                this.model.dataJSON.from    = null
                this.model.dataJSON.to      = null
                this.model.formatted.from   = ''
                this.model.formatted.to     = ''
            }
        }
    },
}